import { AxiosRequestConfig } from "axios";
import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { Category, CategoryUI } from "../entity/category.model";

async function getCategories(): Promise<CategoryUI[]> {
  let page: CategoryUI[] = await api.get(`${mConstants.ORDER_URL}/categories`);

  return page;
}

function getCategory(uuid: string): Promise<Category> {
  return api.get(`${mConstants.ORDER_URL}/categories/${uuid}`);
}

function editCategory(formData: FormData): Promise<void> {
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api.put(`${mConstants.ORDER_URL}/categories`, formData, config);
}
function deleteCategory(uuid: string): Promise<void> {
  return api.delete(`${mConstants.ORDER_URL}/categories/${uuid}`);
}
function addCategory(formData: FormData): Promise<void> {
  const config: AxiosRequestConfig = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api.post(`${mConstants.ORDER_URL}/categories`, formData, config);
}
export const categoryService = {
  getCategories,
  getCategory,
  editCategory,
  deleteCategory,
  addCategory,
};
